import React from 'react';
import get from 'lodash.get';
import {Markdown} from '../Markdown/Markdown';
import slugify from 'slugify';

export function embeddedEntry({data}) {
    if (data.target.__typename === 'ContentfulMarkdownTable') {
        return <Markdown id={data.target.sys.id} />;
    }
    return null;
}

export function headingBlock(node, children) {
    const text = node.content.map(({value}) => value).join('-');
    const id = slugify(text, {lower: true, strict: true});
    const tag = node.nodeType.replace('heading-', 'h');
    return React.createElement(tag, {id}, children);
}

export function assetHyperlink(node, children) {
    const url = get(node, 'data.target.fields.file.url');
    return url ? <a href={url}>{children}</a> : null;
}
